var lib_core = require("lib-core");
var cio_datamodel = require("cio-datamodel");
if(typeof window !== 'undefined')
    var ui_extensions = require("ui-extensions");
var editor_2d = require("editor-2d");

var ShapeWrapperInteractionModel = require("./../../shapeWrapperViewer/shapeWrapperInteractionModel.js");

var GlueInteractionModel = function (data, editorModel) {
    var self = this;

     ShapeWrapperInteractionModel.apply(this, arguments);

    this.showLayer = this.shadow("showLayer",
        function () {
            switch (this.data.layerIndex.getOne()) {
                case 0:
                    return cio_datamodel.FootprintLayers.TOP;
                case 1:
                    return cio_datamodel.FootprintLayers.BOTTOM;
            }
        },
        function (value) {
            this.data.layerIndex.removeAll();
            if (value == cio_datamodel.FootprintLayers.TOP) this.data.layerIndex.add(0);
            else if (value == cio_datamodel.FootprintLayers.BOTTOM) this.data.layerIndex.add(1);
        },
        [this.data.layerIndex]
    );
};
lib_core.inherit(GlueInteractionModel, ShapeWrapperInteractionModel);
GlueInteractionModel.$class = "GlueInteractionModel";

module.exports = GlueInteractionModel;

GlueInteractionModel.prototype.getSnapSet = function () {
    var snapSet = new editor_2d.SnapSet();

    return snapSet;
};

GlueInteractionModel.prototype.getInspectorElements = function () {
    var shapeInspectorElements = this.shapeInteractionModel().getInspectorElements();
    var inspectorElements = {};

    inspectorElements.input_elements = shapeInspectorElements.input_elements;
    inspectorElements.input_elements.push({
            label      : 'Layer',
            type       : ui_extensions.InspectorInputType.SELECTBOX,
            list       : [cio_datamodel.FootprintLayers.TOP, cio_datamodel.FootprintLayers.BOTTOM],
            datamember : this.showLayer,
        }
    );
    inspectorElements.help_elements = {
        'name': 'Glue ' + shapeInspectorElements.help_elements['name']
    };

    return inspectorElements;
};
